module.exports = __webpack_public_path__ + "img/矩形 1456@2x.9fa43e4a.png";